

export default (state = [], action) => {
  if (action.type == "SET_SOUCCOT1") {
    return action.value;
  }
  return state;
};